import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-name" }

import { useTrackersStore } from '@/stores/trackers';
import { name } from '@/utils/name';
import { computed } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  __name: 'VUserInfo',
  props: {
    user: null,
    userId: null,
    onlyName: { type: Boolean },
    size: null
  },
  setup(__props: any) {

const props = __props as { user?: { name: string, surname: string, avatar: string }, userId?: string, onlyName?: boolean, size?: number }



const trackerStore = useTrackersStore()
const user = computed(() => {
  if (props.user) return props.user
  if (!props.userId) return null
  return trackerStore.trackers[props.userId]
})


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(user) && !props.onlyName)
      ? (_openBlock(), _createBlock(_component_v_avatar, {
          key: 0,
          image: _unref(user)?.avatar,
          size: props.size || 26,
          class: "mr-1-5"
        }, null, 8, ["image", "size"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(user)? _unref(name)(_unref(user)): ""), 1)
  ], 64))
}
}

})